import { Col, Container, Row } from "reactstrap";
import DistributionSection from "../../components/Home/DistributionSection";
import HeaderSection from "../../components/Home/HeaderSection";
import MapSection from "../../components/Home/MapSection";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getDistributers } from "../../store/actions/DistributerActions";

const Home = (props) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getDistributers());
    });

    return (
        <>
            <HeaderSection />
            <Container fluid className="my-5  textSection">
                <Row>
                    <Col md={12}>
                        <h1>
                            Filter Your Search By Exactly What You Need!
                            {/* Specific Locations */}
                        </h1>
                        {/* <span>
                            Brick & Mortar Stores, Online Stores or Even your
                            Favorite Brands
                        </span> */}
                    </Col>
                </Row>
            </Container>

            {/* Map Section  */}
            <MapSection />

            {/* DistributionSection */}
            <DistributionSection />
        </>
    );
};

export default Home;
